import {
    createSelector,
} from 'reselect';

const selectCurrentGlobalBannerMessage = () => {
    return 'ten-years-sweepstakes';
};

const selectCurrentGlobalBannerType = () => {
    return 'info'; // enum
};

const selectCurrentGlobalBannerUrl = () => {
    return 'https://www.wanderu.com/blog/10years-sweepstakes/';
};

const selectGlobalBannerVisible = () => {
    return false;
};

const selectGlobalBannerMessage = createSelector(
    selectCurrentGlobalBannerMessage,
    selectCurrentGlobalBannerType,
    selectCurrentGlobalBannerUrl,
    (message, type, url) => ({ message, type, url }),
);

export {
    selectGlobalBannerMessage,
    selectGlobalBannerVisible,
};
